<template>
    <VJoyWrapper class="task-list-progress-bar" direction="row" align="center" column-gap="2" no-margin>
        <VJoyIcon :name="iconInfo.iconName" size="xsmall" :color="iconInfo.color" />
        <VJoyText preset="primary-200">
            {{ $t('profile.section.task.list.progress.bar.label', {nbTasksCompleted: nbTasksCompleted, nbTasks: nbTasks}) }}
        </VJoyText>
        <VJoyProgressBar
            class="task-list-progress-bar__progress-bar"
            :current-step="nbTasksCompleted"
            :percentage="percentage"
            :color="iconInfo.color"
            show-label
            :steps="nbTasks"
        />
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyProgressBar, VJoyWrapper, VJoyIcon, VJoyText} from '@maltjoy/core-vue';
    import type {TJoyProgressBarColors} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';
    import type {TaskListItemType} from '../types/TaskListItemType';

    const props = defineProps<{tasks: TaskListItemType[]}>();

    const nbTasks = computed(() => props.tasks.length);
    const nbTasksCompleted = computed(() => props.tasks.filter((task) => task.completed).length);
    const percentage = computed(() => Math.ceil((nbTasksCompleted.value / nbTasks.value) * 100));

    const iconInfo = computed<{color: TJoyProgressBarColors; iconName: JoyIconsId}>(() => {
        if (percentage.value >= 100) {
            return {color: 'success', iconName: 'check-circle'};
        }
        if (percentage.value <= 0) {
            return {color: 'error', iconName: 'warning'};
        }
        return {color: 'warning', iconName: 'rocket'};
    });
</script>
<style scoped lang="scss">
    .task-list-progress-bar {
        width: 100%;

        &__progress-bar {
            flex: 1;
            margin: 0;
        }
    }
</style>
